/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import { Button } from "../../../../shared/widgets";
import { GenericLoaderComponent } from "../../../../shared/widgets/genericLoader";
import "../contractStyle.css";
import { MessageType, templateStrings } from "../../../../Constant";
import BusinessDetails from "./businessDetails";
import { ContractDetails } from "./contractDetails";
import validateContract from "../validator/createContractValidator";
import validateBusinessDetail from "../validator/businessDetailValidator";
import validateExpenses from "../validator/expensesValidator";
import { createContractService, editContractService } from "../../../../services/contractService";
import { refreshUpliftAction, updateBorneByAction } from "../../../../redux/action-creators/contractedActionCreator";

class CreateContractModal extends Component {
  constructor(props) {
    super(props);
    const {
      activeStep, requestType, steps, selectedVehicle,
    } = this.props;
    this.state = {
      contractDetailError: {},
      activeStep,
      requestType,
      steps,
      from: null,
      to: null,
      disable: false,
      expenses: [],
      businessDetails: [
        {
          contractType: "",
          baseline: "",
          unit: "",
          kmWisePaidAmount: "",
          dayWisePaidAmount: "",
          is_threshold: false,
          kmWiseThreshold: "",
          penalty: "",
          thresholdTypeBG: "",
          epkmBG: "",
          travelKmBG: "",
          is_capping: false,
          cappingAmount: "",
          criteria: "",
          flatFee: "",
          percentageCriteria: "",
          baselineCriteria: "",
          fee: "",
          ticketCountType: "",
          percentage: "",
          baselinePercentage: [{
            baseline: "", percentageCriteria: "", percentage: "", baselineFlatFee: "",
          }],
          flatFeeOn: "",
          daysToInclude: "waybillDays",
          minimumRides: "",
          subscriptionPlan: props.activePlans.find((plan) => plan.planCategory === "basic")?.planId,
          selectedAddOns: [],
        },
      ],
      isNextClicked: false,
      vehiclesSelected: selectedVehicle.map((vehicle) => {
        // eslint-disable-next-line no-param-reassign
        vehicle.checked = true;
        return vehicle;
      }),
    };
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleBorneBy = this.handleBorneBy.bind(this);
  }

  componentDidMount() {
    const { vehiclesSelected } = this.state;
    const { contractData } = this.props;
    this.setState({
      checkedVehicles: vehiclesSelected.filter((vehicle) => vehicle.checked),
    });
    const { expenseArray } = templateStrings;
    const expensesList = expenseArray.map((expense) => {
      this.setState({
        [expense.name]: { applicable: false, amount: "", percentage: "" },
      });
      return {
        applicable: false, amount: "", percentage: "", label: expense.label, name: expense.name,
      };
    });
    this.setState({
      expenses: expensesList,
    });
    if (contractData) {
      this.setData(contractData);
    }
  }

  handleNext() {
    const { isNextClicked, activeStep, steps } = this.state;
    if (isNextClicked) {
      this.setState({
        isNextClicked: false,
      });
      if (activeStep < steps.length - 1) {
        this.setState({
          activeStep: activeStep + 1,
        });
      }
      if (activeStep === steps.length - 1) {
        this.setState({ disable: true });
        this.modifyContract();
      }
    }
  }

  handleBack() {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  }

  handleBorneBy(isNext) {
    this.setState({ isNextClicked: isNext }, () => this.handleNext());
  }

  onContractService(contractDetails, type) {
    const { messageCallBack, setTokenExpired } = this.props;
    (type === "create" ? createContractService(contractDetails) : editContractService(contractDetails))
      .then((response) => {
        messageCallBack(MessageType.SUCCESS, response.message ? response.message : "Contract Created Successfully");
        this.setState({ disable: false });
      })
      .then(() => {
        // Not in use anymore
        // refreshUplift();
      })
      .catch((err) => {
        if (err.message.includes("Invalid token")) {
          setTokenExpired(true);
        } else {
          messageCallBack(MessageType.ERROR, err.message ? err.message : "Error occurred ");
        }
        this.setState({ disable: false });
      });
  }

  setData(contractData) {
    const { activePlans } = this.props;
    this.setStateData("from", null);
    this.setStateData("to", null);

    // eslint-disable-next-line no-unused-expressions
    contractData.borneBy
      ? this.setStateData("borneBy", contractData.borneBy)
      : this.setStateData("borneBy", "chalo");

    if (contractData.businessDeals && contractData.businessDeals.length > 0) {
      const businessDetails = [...contractData.businessDeals];
      contractData.businessDeals.forEach((One, index) => {
        if (One.modeAndPercentage && One.modeAndPercentage.length > 0) {
          businessDetails[index].percentageCriteria = One.modeAndPercentage[0].percentageCriteria;
          businessDetails[index].percentage = One.modeAndPercentage[0].percentage;
        }
        if (businessDetails[index]?.contractType === "flatFee" && businessDetails[index]?.flatFeeOn === "perBus") {
          const defaultPlan = activePlans.find((plan) => plan.planCategory === "basic");
          businessDetails[index].subscriptionPlan = contractData?.subscription?.planId
          || defaultPlan?.planId;
          businessDetails[index].selectedAddOns = contractData?.subscription?.addOns?.map(
            (addOn) => addOn.version,
          ) || [];
        }
      });
      this.setStateData("businessDetails", [...businessDetails]);
    }
    if (contractData.expenses && contractData.expenses.length > 0) {
      this.setExpenses(contractData.expenses);
    }
  }

  setStateData(input, value) {
    this.setState({
      [input]: value,
    });
  }

  setExpenses(expenses) {
    expenses.map((expense) => {
      this.setState({
        [expense.type]: {
          applicable: true,
          amount: expense.amount ? expense.amount : "",
          percentage: expense.percentage ? expense.percentage : "",
        },
      });
      return null;
    });
  }

  validateNext = () => {
    const { activeStep } = this.state;
    let errorObj;
    switch (activeStep) {
      case 0:
        errorObj = this.updateContractFormErrorState();
        break;
      case 1:
        errorObj = this.updateBusinessFormErrorState();
        break;
      default:
        break;
    }
    return errorObj && Object.keys(errorObj).length === 0;
  };

  addClick = (addType, index) => {
    const { businessDetails: businessDetailsState } = this.state;
    if (addType && addType === "businessDetails") {
      this.setState((prevState) => ({
        businessDetails: [
          ...prevState.businessDetails,
          {
            contractType: "",
            baseline: "",
            kmWisePaidAmount: "",
            dayWisePaidAmount: "",
            is_threshold: false,
            kmWiseThreshold: "",
            penalty: "",
            epkmBG: "",
            thresholdTypeBG: "",
            travelKmBG: "",
            is_capping: false,
            cappingAmount: "",
            criteria: "",
            flatFee: "",
            percentageCriteria: "",
            baselineCriteria: "",
            ticketCountType: "",
            fee: "",
            percentage: "",
            baselinePercentage: [{
              baseline: "", percentageCriteria: "", percentage: "", baselineFlatFee: "",
            }],
          },
        ],
      }));
    } else if (addType && addType === "baselinePercentage") {
      const businessDetails = [...businessDetailsState];
      businessDetails[index].baselinePercentage = [
        ...businessDetails[index].baselinePercentage,
        {
          baseline: "", percentageCriteria: "", percentage: "", baselineFlatFee: "",
        },
      ];
      this.setState(() => ({
        businessDetails: [...businessDetails],
      }));
    }
  };

  removeClick = (i, type, typeIndex) => {
    const { businessDetails: businessDetailsState } = this.state;
    const businessDetails = [...businessDetailsState];
    if (!type) {
      businessDetails.splice(i, 1);
    } else if (
      businessDetails
        && businessDetails.length > 0
        && businessDetails[i]
        && businessDetails[i][type]
        && businessDetails[i][type].length > 0
        && businessDetails[i][type][typeIndex]
    ) {
      businessDetails[i][type].splice(typeIndex, 1);
    }
    this.setState({ businessDetails });
  };

  // eslint-disable-next-line class-methods-use-this
  handleSelectedAddOnsInput = (
    objProp,
    businessDetails,
    index,
    input,
    businessDetailsState,
    value,
  ) => {
    if (objProp?.isRemove) {
      businessDetails[index][input] = businessDetailsState[index][input].filter(
        (item) => item !== objProp.value,
      );
    } else {
      businessDetails[index][input] = businessDetailsState[index][input]?.includes(
        value.target.value,
      )
        ? businessDetailsState[index][input]
        : [...(businessDetailsState[index][input] || []), value.target.value];
    }
  };

  handleEventTypeChange = (input, objProp, index, value) => {
    const { businessDetails: businessDetailsState, activeStep } = this.state;
    if (activeStep === 1) {
      const businessDetails = [...businessDetailsState];
      if (input === "selectedAddOns") {
        this.handleSelectedAddOnsInput(
          objProp,
          businessDetails,
          index,
          input,
          businessDetailsState,
          value,
        );
      } else {
        businessDetails[index][input] = objProp
          ? { ...this.state[input], [objProp]: value.target.value }
          : value.target.value;
        if (input === "flatFeeCriteria" && value.target.value === "perMonth") {
          businessDetails[index].flatFeeOn = "";
        }
      }
      this.setState(
        {
          businessDetails,
        },
        () => {
          this.updateFormErrorState();
        },
      );
    } else {
      this.setState(
        {
          [input]: objProp ? {
            ...this.state[input],
            [objProp]: value.target.value,
          } : value.target.value,
        },
        () => {
          this.updateFormErrorState();
        },
      );
    }
  };

  handleChange = (input, type, objProp, index) => (value) => {
    const { businessDetails: businessDetailsState, activeStep } = this.state;
    switch (type) {
      case "event":
        this.handleEventTypeChange(input, objProp, index, value);
        break;
      case "nested":
        if (activeStep === 1) {
          const businessDetails = [...businessDetailsState];
          businessDetails[index].baselinePercentage[objProp][input] = value.target.value;
          this.setState(
            {
              businessDetails,
            },
            () => {
              this.updateFormErrorState();
            },
          );
        }
        break;
      case "value":
        this.setState({ [input]: value }, () => {
          this.updateFormErrorState();
        });
        break;
      case "checked":
        if (activeStep === 1) {
          const businessDetails = [...businessDetailsState];
          businessDetails[index][input] = objProp
            ? { ...this.state[input], [objProp]: value.target.checked }
            : value.target.checked;
          this.setState(
            {
              businessDetails,
            },
            () => {
              this.filterCheckedVehicles();
              this.updateFormErrorState();
            },
          );
        } else {
          this.setState(
            {
              [input]: objProp
                ? { ...this.state[input], [objProp]: value.target.checked }
                : value.target.checked,
            },
            () => {
              this.filterCheckedVehicles();
              this.updateFormErrorState();
            },
          );
        }
        break;
      case "list":
        this.setState(
          {
            [input]: value,
          },
          () => {
            this.filterCheckedVehicles();
            this.updateFormErrorState();
          },
        );
        break;
      default:
        break;
    }
  };

  /**
   * validates contract form data
   * @param target
   */

  // eslint-disable-next-line class-methods-use-this
  createBusinessGuaranteedContract = (One, raw) => {
    if (One.contractType && One.contractType === "businessGuaranteed") {
      raw.unit = One.unit;
      if (One.is_capping && One.unit === "perDay") {
        raw.is_capping = One.is_capping;
        raw.cappingAmount = +One.cappingAmount;
      }
      if (One.is_threshold) {
        if (One.unit === "perDay") {
          raw.epkmBG = +One.epkmBG;
          raw.travelKmBG = +One.travelKmBG;
          raw.thresholdTypeBG = One.thresholdTypeBG;
        } else if (One.unit === "perKm") {
          raw.kmWiseThreshold = +One.kmWiseThreshold;
          raw.penalty = +One.penalty;
        }
        raw.is_threshold = One.is_threshold;
      }

      if (One.unit === "perDay") {
        raw.dayWisePaidAmount = +One.dayWisePaidAmount;
      } else {
        raw.kmWisePaidAmount = +One.kmWisePaidAmount;
      }
    }
  };

  // eslint-disable-next-line class-methods-use-this
  createRevenueShareContract = (One, raw) => {
    if (One.contractType === "revenueShare") {
      raw.criteria = One.criteria;
      if (One.criteria === "percentageBased") {
        raw.modeAndPercentage = [{
          percentageCriteria: One.percentageCriteria,
          percentage: +One.percentage,
        }];
      }
      if (One.criteria === "perTicketBased") {
        raw.perTicketBased = [{ ticketCountType: One.ticketCountType, fee: +One.fee }];
      }
    }
  };

  // eslint-disable-next-line class-methods-use-this
  createFlatFeeContract = (One, raw, activePlans, activeAddOns) => {
    if (One.contractType === "flatFee") {
      raw.flatFeeCriteria = One.flatFeeCriteria;
      raw.flatFee = +One.flatFee;
      raw.flatFeeOn = One.flatFeeOn;
      raw.daysToInclude = One.daysToInclude;
      if (One.flatFeeOn === "perRide") {
        raw.minimumRides = +One.minimumRides;
      } else {
        const defaultPlan = activePlans.find((plan) => plan.planCategory === "basic");
        raw.planName = activePlans.find(
          (plan) => plan.planId === +One.subscriptionPlan,
        )?.planName || defaultPlan.planName;
        raw.planVersion = +(One.subscriptionPlan || defaultPlan.planId);
        raw.subscriptionAddOns = One.selectedAddOns?.map((selectedAddOn) => {
          const addOnDetail = activeAddOns.find((addOn) => addOn.addOnId === selectedAddOn);
          return {
            name: addOnDetail.addOnName,
            version: addOnDetail.addOnId,
          };
        });
      }
    }
  };

  // eslint-disable-next-line class-methods-use-this
  createBaselineContract = (One, raw) => {
    if (One.contractType === "baseline" && One.baselineCriteria) {
      raw.baselineCriteria = One.baselineCriteria;
      if (One.baselinePercentage && One.baselinePercentage.length > 0) {
        One.baselinePercentage.forEach((record) => {
          record.baseline = +record.baseline;
          record.percentage = +record.percentage;
          record.baselineFlatFee = +record.baselineFlatFee;
        });
        raw.baselinePercentage = One.baselinePercentage;
      }
    }
  };

  updateFormErrorState() {
    const { activeStep } = this.state;
    switch (activeStep) {
      case 0:
        this.updateContractFormErrorState();
        break;
      case 1:
        this.updateBusinessFormErrorState();
        break;
      case 2:
        this.updateExpenseFormErrorState();
        break;
      default:
        break;
    }
  }

  updateContractFormErrorState() {
    const formState = validateContract(this.state);
    this.setState({
      contractDetailError: formState,
    });
    return formState;
  }

  updateBusinessFormErrorState() {
    const {
      businessDetailError: formState,
      businessDetailStepError,
    } = validateBusinessDetail(this.state);
    this.setState({
      businessDetailError: formState,
    });
    return businessDetailStepError;
  }

  updateExpenseFormErrorState() {
    const formState = validateExpenses(this.state);
    this.setState({
      expenseError: formState,
    });
    return formState;
  }

  updateBorneBy() {
    const {
      activeStep, from, to, checkedVehicles,
    } = this.state;
    const { updateBorneByDispatch, forEdit } = this.props;
    this.setState({ isNextClicked: true }, () => {
      if (this.validateNext()) {
        if (activeStep === 0) {
          updateBorneByDispatch({
            fromDate: from,
            toDate: to,
            busNumbers: checkedVehicles.map((vehicle) => vehicle.busNumber),
            handleBorneBy: this.handleBorneBy,
            forEdit,
          });
        } else {
          this.handleNext();
        }
      }
    });
  }

  modifyContract() {
    const { city, activePlans, activeAddOns } = this.props;
    const {
      requestType, from, to, checkedVehicles,
    } = this.state;
    const busNumbersArr = [];
    checkedVehicles.map((val) => (
      busNumbersArr.push(val.busNumber)
    ));
    const contractDetails = {
      fromDate: from,
      toDate: to,
      busNumbers: busNumbersArr,
      cityId: city,
    };

    const { businessDetails = [] } = this.state;
    if (businessDetails && businessDetails.length > 0) {
      const businessDeals = [];
      businessDetails.forEach((One) => {
        const raw = {};
        raw.contractType = One.contractType;
        this.createBusinessGuaranteedContract(One, raw);
        this.createRevenueShareContract(One, raw);
        this.createFlatFeeContract(One, raw, activePlans, activeAddOns);
        this.createBaselineContract(One, raw);
        businessDeals.push(raw);
      });
      contractDetails.businessDeals = businessDeals;
    }

    contractDetails.expenses = [];
    typeof (requestType) === "string" && ((requestType === "renew" || requestType === "create") ? this.onContractService(contractDetails, "create") : this.onContractService(contractDetails, "edit"));
  }

  filterCheckedVehicles() {
    this.setState(
      {
        checkedVehicles: this.state.vehiclesSelected.filter((vehicle) => vehicle.checked),
      },
      () => {
        this.updateContractFormErrorState();
      },
    );
  }

  renderSwitch() {
    const values = this.state;
    const { activeStep } = values;
    switch (activeStep) {
      case 0:
        return (
          <ContractDetails
            values={values}
            handleChange={this.handleChange}
            setDefaultBorneBy={(val) => this.setState({ borneBy: val })}
          />
        );
      case 1:
        return (
          <BusinessDetails
            values={values}
            handleChange={this.handleChange}
            addClick={this.addClick}
            removeClick={this.removeClick}
          />
        );
      default:
        return "default";
    }
  }

  render() {
    const { showModal, messageCallBack } = this.props;
    const { disable, activeStep, steps } = this.state;
    return (
      <Dialog
        onClose={() => messageCallBack(null, null)}
        aria-labelledby="customized-dialog-title"
        open={showModal}
        className="dialogWrapper"
      >
        {disable && <GenericLoaderComponent absolute />}
        <DialogTitle id="customized-dialog-title" onClose={() => messageCallBack(null, null)}>
          <div className="modalHeaderWrapper">
            <Stepper activeStep={activeStep} className="stepperWrapper">
              {steps.map((label) => {
                const stepProps = {};
                const labelProps = {};

                return (
                  <Step key={label} {...stepProps} className="stepStyle">
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            <div role="button" className="closeIcon" onClick={() => messageCallBack(null, null)} onKeyDown={() => { /* onKeyDown */ }} tabIndex="0" aria-label="close">
              <CloseIcon />
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <div>{this.renderSwitch()}</div>
        </DialogContent>
        <DialogActions>
          {activeStep > 0 && (
            <Button
              disable={disable}
              classname="backBtnContainer"
              onClick={() => {
                this.handleBack();
              }}
              buttonText="Back"
            />
          )}
          <Button
            disable={disable}
            classname="submitBtnContainer"
            onClick={() => {
              this.updateBorneBy();
            }}
            buttonText={activeStep === steps.length - 1 ? "Done" : "Next"}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

CreateContractModal.defaultProps = {
  showModal: false,
};
CreateContractModal.propTypes = {
  showModal: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  messageCallBack: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    activePlans: state?.Contracts?.subscriptonPlansDetail?.activePlans || [],
    activeAddOns: state?.Contracts?.subscriptonPlansDetail?.activeAddOns || [],
  };
}

const mapDispatchToProps = (dispatch) => ({
  refreshUplift: () => {
    dispatch(refreshUpliftAction());
  },
  updateBorneByDispatch: (params) => {
    dispatch(updateBorneByAction(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateContractModal);
